import type { NamedStateStorage } from './createSharedSlice';

/**
 * @description
 * Used together with createSharedSlice to create a persistent storage for the shared slice.
 *
 * @example
 * export const useRememberFiltersStorage = createSharedSlice({
 *   initialState: { counter: 0 },
 *   name: `example-shared-slice`,
 *   storage: createSessionStorage('example-shared-slice'),
 *   reducers: {
 *       increment: (state) => { state.count += 1; },
 *   },
 * });
 *
 * @param name - The name of the session storage. Must be unique. It is used as a key for the Session Storage.
 * @returns A NamedStateStorage object representing the session storage.
 */
export function createSessionStorage(name: string): NamedStateStorage {
    return {
        name,
        getItem: sessionStorage.getItem.bind(sessionStorage),
        setItem: sessionStorage.setItem.bind(sessionStorage),
        removeItem: sessionStorage.removeItem.bind(sessionStorage),
    };
}
